import * as Common from '../common'
import * as Request from '../../request'

export const FETCH_SURVEY_RESULTS = 'FETCH_SURVEY_RESULTS'
export const FETCH_SURVEY_RESULTS_SUCCESS = 'FETCH_SURVEY_RESULTS_SUCCESS'
export const FETCH_SURVEY_RESULTS_FAILURE = 'FETCH_SURVEY_RESULTS_FAILURE'

export const STORE_SURVEY_RESULT = 'STORE_SURVEY_RESULT'
export const STORE_SURVEY_RESULT_SUCCESS = 'STORE_SURVEY_RESULT_SUCCESS'
export const STORE_SURVEY_RESULT_FAILURE = 'STORE_SURVEY_RESULT_FAILURE'

export const INITIALIZE_SURVEY_RESULTS_FROM_URL = 'INITIALIZE_SURVEY_RESULTS_FROM_URL'
export const REDIRECT_TO_FINAL_URL = 'REDIRECT_TO_FINAL_URL'
export const LOAD_SURVEY_RESULTS_PAGE = 'LOAD_SURVEY_RESULTS_PAGE'

export interface SurveyOption {
  id: number;
  option_id?: number; // Keep for backward compatibility
  title: string;
  response_count: number;
  percentage: number;
  is_correct: boolean;
  sequence: number;
}

export interface Survey {
  id: number;
  name: string;
  question: string;
  is_multi_select: boolean;
  hide_results: boolean;
  success_message?: string;
  fail_message?: string;
  final_url?: string;
}

export interface FetchSurveyResultsAction {
  type: typeof FETCH_SURVEY_RESULTS;
  payload: {
    communityIdentifier: Common.CommunityIdentifier;
    surveyId: string;
  };
}

export interface FetchSurveyResultsSuccessAction {
  type: typeof FETCH_SURVEY_RESULTS_SUCCESS;
  payload: {
    survey: Survey;
    options: SurveyOption[];
    configurations: any;
  };
}

export interface FetchSurveyResultsFailureAction {
  type: typeof FETCH_SURVEY_RESULTS_FAILURE;
  payload: {
    errorMessage: string;
  };
}

export interface StoreSurveyResultAction {
  type: typeof STORE_SURVEY_RESULT;
  payload: {
    token: string;
    surveyOptionId: number;
  };
}

export interface StoreSurveyResultSuccessAction {
  type: typeof STORE_SURVEY_RESULT_SUCCESS;
  payload: {
    message: string;
    is_already_submitted: boolean;
    is_correct: boolean;
    success_message?: string;
    fail_message?: string;
  };
}

export interface StoreSurveyResultFailureAction {
  type: typeof STORE_SURVEY_RESULT_FAILURE;
  payload: {
    errorMessage: string;
  };
}

export interface InitializeFromUrlAction {
  type: typeof INITIALIZE_SURVEY_RESULTS_FROM_URL;
  payload: {
    communityIdentifier: string;
    surveyId: string;
    guid?: string;
    surveyOptionId?: string;
    token?: string;
  };
}

export interface RedirectToFinalUrlAction {
  type: typeof REDIRECT_TO_FINAL_URL;
  payload: {
    finalUrl: string;
  };
}

export interface LoadSurveyResultsPageAction {
  type: typeof LOAD_SURVEY_RESULTS_PAGE;
  payload: {
    communityIdentifier: string;
    surveyId: string;
    token?: string;
    surveyOptionId?: string;
  };
}

export type SurveyResultsActionTypes = 
  | FetchSurveyResultsAction
  | FetchSurveyResultsSuccessAction
  | FetchSurveyResultsFailureAction
  | StoreSurveyResultAction
  | StoreSurveyResultSuccessAction
  | StoreSurveyResultFailureAction
  | InitializeFromUrlAction
  | RedirectToFinalUrlAction
  | LoadSurveyResultsPageAction;

export const fetchSurveyResults = (surveyId: string, communityIdentifier: string) => 
  Request.requestActionCreator<Request.RequestOptions>(FETCH_SURVEY_RESULTS)
  ({
    method: 'GET',
    public: true,
    url: `/survey/${communityIdentifier}/${surveyId}/results`,
  });

export const storeSurveyResult = (token: string, surveyOptionId: number, communityIdentifier: string) => {
  return Request.requestActionCreator<Request.RequestOptions<{ token: string, survey_option_id: number }>>(STORE_SURVEY_RESULT)
  ({
    method: 'POST',
    public: true,
    url: `/survey/${communityIdentifier}/result`,
    payload: {
      token,
      survey_option_id: surveyOptionId,
    },
  });
};

export const redirectToFinalUrl = (finalUrl: string): RedirectToFinalUrlAction => ({
  type: REDIRECT_TO_FINAL_URL,
  payload: { finalUrl }
});

export const loadSurveyResultsPage = (
  communityIdentifier: string,
  surveyId: string,
  token?: string,
  surveyOptionId?: string
): LoadSurveyResultsPageAction => ({
  type: LOAD_SURVEY_RESULTS_PAGE,
  payload: { communityIdentifier, surveyId, token, surveyOptionId }
});